<template>
  <div class="container-EXPONDO">
    <div class="content-block-wrapper flex flex-wrap flex-col gap-4">
      <div class="gap-4 lg:grid grid-cols-[2fr_1fr]">
        <SkeletonLoader
          height="360px"
          class="lg:block hidden"
        />
        <SkeletonLoader
          height="360px"
          class="lg:block hidden"
        />
        <SkeletonLoader
          height="388px"
          class="lg:hidden block"
        />
      </div>
      <SkeletonLoader
        width="100%"
        height="56px"
        class="lg:block hidden"
      />
      <SkeletonLoader
        width="100%"
        height="172px"
        class="lg:hidden block"
      />
      <SkeletonLoader
        :number-of-items="2"
        width="50%"
        height="261px"
        class="w-full lg:flex gap-4 hidden"
      />
      <SkeletonLoader
        :number-of-items="2"
        height="261px"
        class="w-full gap-4 lg:hidden flex flex-col"
      />
      <SkeletonLoader
        :number-of-items="9"
        height="140px"
        class="w-full lg:flex gap-4 hidden"
      />
      <SkeletonLoader
        :number-of-items="9"
        height="140px"
        class="grid auto-cols-auto gap-4 grid-cols-3 lg:hidden"
      />
      <SkeletonLoader
        width="100%"
        height="60px"
        class="lg:block hidden"
      />
      <SkeletonLoader
        width="100%"
        height="162px"
        class="lg:hidden block"
      />
      <div class="related-products w-full flex flex-col gap-4">
        <SkeletonLoader
          :number-of-items="4"
          width="335px"
          height="763px"
          class="w-full lg:flex gap-8 hidden"
        />
        <SkeletonLoader
          width="50%"
          height="54px"
          class="lg:hidden block"
        />
        <SkeletonLoader
          :number-of-items="4"
          width="229px"
          height="419px"
          class="flex gap-4 lg:hidden"
        />
        <SkeletonLoader
          width="100%"
          height="50px"
          class="lg:hidden block px-4"
        />
      </div>
      <div class="related-products w-full flex flex-col gap-4">
        <SkeletonLoader
          :number-of-items="4"
          width="335px"
          height="763px"
          class="w-full lg:flex gap-8 hidden"
        />
        <SkeletonLoader
          width="50%"
          height="54px"
          class="lg:hidden block"
        />
        <SkeletonLoader
          :number-of-items="4"
          width="229px"
          height="419px"
          class="flex gap-4 lg:hidden"
        />
        <SkeletonLoader
          width="100%"
          height="50px"
          class="lg:hidden block px-4"
        />
      </div>
      <SkeletonLoader
        :number-of-items="2"
        height="260px"
        class="lg:flex gap-4 hidden"
      />
      <SkeletonLoader
        :number-of-items="2"
        height="282px"
        class="flex flex-col gap-4 lg:hidden"
      />
      <div class="grid lg:grid-cols-2 gap-4 w-full">
        <div>
          <SkeletonLoader
            width="50%"
            height="62px"
            class="lg:block hidden mb-4"
          />
          <SkeletonLoader
            width="50%"
            height="54px"
            class="lg:hidden block mb-4"
          />
          <SkeletonLoader
            height="246px"
          />
        </div>
        <div>
          <SkeletonLoader
            width="50%"
            height="62px"
            class="lg:block hidden mb-4"
          />
          <SkeletonLoader
            width="50%"
            height="54px"
            class="lg:hidden block mb-4"
          />
          <SkeletonLoader
            height="246px"
          />
        </div>
      </div>
      <div class="w-full">
        <SkeletonLoader
          width="100%"
          height="48px"
          class="lg:block hidden"
        />
        <SkeletonLoader
          width="100%"
          height="60px"
          class="lg:hidden block"
        />
        <SkeletonLoader
          width="100%"
          height="52px"
          class="lg:block hidden my-4"
        />
        <SkeletonLoader
          width="100%"
          height="130px"
          class="lg:hidden block my-4"
        />
        <SkeletonLoader
          width="30%"
          height="28px"
          class="mx-auto flex justify-center mb-8"
        />
        <div class="lg:w-9/12 lg:mx-auto">
          <SkeletonLoader
            :number-of-items="8"
            height="64px"
            class="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-6 lg:gap-y-10"
          />
        </div>
      </div>
      <SkeletonLoader
        width="50%"
        height="48px"
        class="flex justify-center"
      />
      <SkeletonLoader
        :number-of-items="9"
        width="130px"
        height="24px"
        class="flex flex-col items-center lg:flex-row gap-4"
      />
    </div>
  </div>
</template>
<script lang="ts">

export default defineComponent({
  name: 'HomePageSkeleton',
});

</script>
